import {
  buildLaunchDarklyContextFromState,
  hasLaunchDarklyCharityContext,
} from '@/utils/launchDarklyContext'

export default {
  computed: {
    launchDarklyContext() {
      return buildLaunchDarklyContextFromState(this.$store.state)
    },
  },

  mounted() {
    if (
      !hasLaunchDarklyCharityContext(this.launchDarklyContext) &&
      !this.isAdminLoginRoute(this.$route)
    ) {
      return
    }

    this.updateLaunchDarklyContexts()
  },

  methods: {
    isAdminLoginRoute(route) {
      const currentRoute = route || {}
      return Boolean(
        currentRoute.name === 'adminLogin' ||
          currentRoute.path === '/admin/login' ||
          (Array.isArray(currentRoute.matched) &&
            currentRoute.matched.some((record) => record && record.name === 'adminLogin'))
      )
    },

    async updateLaunchDarklyContexts() {
      await this.$store.dispatch('featureFlags/syncLaunchDarklyContext')
    },
  },

  watch: {
    $route: {
      handler: function (newRoute) {
        if (
          hasLaunchDarklyCharityContext(this.launchDarklyContext) ||
          this.isAdminLoginRoute(newRoute)
        ) {
          this.updateLaunchDarklyContexts()
        }
      },
      deep: true,
    },
    launchDarklyContext: {
      handler: function (context) {
        if (!hasLaunchDarklyCharityContext(context)) {
          return
        }

        this.updateLaunchDarklyContexts()
      },
      deep: true,
    },
  },
}
